<template>
  <ul class="nav nav-tabs mr-md-0 mr-2" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#dtab5" role="tab" aria-controls="dtab5">
        <img src="@/assets/images/tab-icon-5.png" alt="img">
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#dtab1" role="tab" aria-controls="dtab1">
        <img src="@/assets/images/tab-icon-1.png" alt="img">
      </a>
    </li>


<!--    <li class="nav-item">-->
<!--      <a class="nav-link" data-toggle="tab" href="#dtab2" role="tab" aria-controls="dtab2">-->
<!--        <img src="@/assets/images/tab-icon-2.png" alt="img">-->
<!--      </a>-->
<!--    </li>-->

<!--    <li class="nav-item">-->
<!--      <a class="nav-link" data-toggle="tab" href="#dtab3" role="tab" aria-controls="dtab3">-->
<!--        <img src="@/assets/images/tab-icon-3.png" alt="img">-->
<!--      </a>-->
<!--    </li>-->
<!--    <li class="nav-item">-->
<!--      <a class="nav-link" data-toggle="tab" href="#dtab4" role="tab" aria-controls="dtab4">-->
<!--        <img src="@/assets/images/tab-icon-4.png" alt="img">-->
<!--      </a>-->
<!--    </li>-->


<!--    <li class="nav-item">-->
<!--      <a class="nav-link" data-toggle="tab" href="#dtab6" role="tab" aria-controls="dtab6">-->
<!--        <img src="@/assets/images/tab-icon-6.png" alt="img">-->
<!--      </a>-->
<!--    </li>-->
  </ul>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/AllTabsLinks.vue